import React, { useContext, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { ReverseCollectContext } from '../..';

export const ModalCollectCreated = () => {
  const { Modal } = useModal();

  const { protocolCollectCreated } = useContext(ReverseCollectContext);

  const handleCloseModal = () => {
    window.location.reload();
  };

  return (
    <Modal preventClose>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16
        }}
      >
        <ModalTitle>ATENÇÃO</ModalTitle>

        <ModalText>Pedido de coleta concluído com sucesso.</ModalText>
        <ModalText>Protocolo: {protocolCollectCreated}</ModalText>
        <ModalText>
          Em breve será enviado um e-mail com os <br />
          detalhes da sua solicitação.
        </ModalText>

        <Button type="button" variant="contained" onClick={handleCloseModal}>
          OK
        </Button>
      </Box>
    </Modal>
  );
};
